import React from 'react'
import './footer.css'
import logo_kaleidoskop from '../ui/logo.svg'
import { NavLink } from 'react-router-dom'
import logo_kampnagel from '../ui/kampnagel_logo.svg'
const Footer = () => {
  return (


    <div>

      <div id='footer'>




        <div id='kaleidoskopLogo'>
          <img src={logo_kaleidoskop} alt="" />
        </div>

        <div id='SubPages'>

          <ul>



            <li><NavLink to="">Startseite</NavLink></li>
            <li><NavLink to="kaleidoskop">[k]kaleidoskop</NavLink></li>
            <li><NavLink to="archive">Archiv</NavLink></li>
            <li><NavLink to="textbook">Textbuch</NavLink></li>
            <li><NavLink to="impressum">Impressum</NavLink></li>


          </ul>





        </div>

        <div id='kampnagel_logo'>

          <a href="https://kampnagel.de/" target='_blank' rel="noopener noreferrer">
            <img src={logo_kampnagel} alt="" />
          </a>

          <div>&copy; 2024 [k]KAMPNAGEL</div>

        </div>






      </div>





    </div>

  )
}

export default Footer